"use client";

import { TypeMultiPurposeBanner } from "@contentful/types";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@yardzen/ui/components/button";
import { useRouter } from "next/navigation";

export function MultiPurposeBanner({
  multiPurposeBanner,
}: {
  multiPurposeBanner: TypeMultiPurposeBanner<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  const router = useRouter();
  const { title, iconToggle, heading, bodyCopy, cta } =
    multiPurposeBanner.fields;

  const ctaUrl = cta?.fields.url;
  const ctaButtonText = cta?.fields.buttonText;

  return (
    <div className="flex w-full flex-col items-center justify-center px-8">
      <div className="bg-brand-tertiary-30 flex flex-col items-start justify-start gap-2 rounded-lg px-4 py-4 shadow-md md:w-full md:max-w-7xl md:flex-row md:items-center md:justify-center md:gap-0 md:py-8">
        <div className="flex flex-row">
          {iconToggle && (
            <div className="mr-4 flex items-center justify-center">
              <span
                role="img"
                aria-label="sparkles"
                className="text-2xl md:text-4xl"
              >
                ✨
              </span>
            </div>
          )}
          <div className="font-display flex min-w-56 items-center pr-4 text-base font-bold leading-[120%] md:text-xl">
            {heading}
          </div>
        </div>
        <div className="text-brand-primary-light max-w-3xl text-base font-light md:text-lg">
          {bodyCopy}
        </div>
        <div className="w-full flex-shrink-0 md:w-auto">
          <Button
            variant="secondary"
            className="w-full md:w-auto"
            endIcon={<FontAwesomeIcon icon={faArrowRight} />}
            onClick={() => {
              if (ctaUrl) {
                router.push(ctaUrl);
              }
            }}
          >
            {ctaButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
}
